export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7815.2992be8d.jpg";